import ChartInfo from "./chartInfo";
import PatternFillType from "./charts/patternFill";
import Fund from "./fund";

class FundInfo {
    trusteeBankAccount: Fund = new Fund(
        1,
        'Trustee Bank Account',
        'The trustee bank account holds one percent of assets in order to provide for operational costs such as fees.',
        false,
        new ChartInfo('RoyalBlue', PatternFillType.None, 4)
    );

    moneyFund: Fund = new Fund(
        2,
        'Money Fund',
        'This fund aims to provide a high level of current income, aligned to global returns on cash, and preserve investor\'s original investment.',
        true,
        new ChartInfo('#00439A', PatternFillType.None, 3));

    matchingIncomeFund: Fund = new Fund(
        3,
        'Matching Income Fund',
        'This fund is designed to deliver a regular source of income, paid monthly, and aims to limit downside risk over rolling three-year periods. The fund will invest in a broad mix of different asset types and accesses higher income investments to smooth income over time for investors.',
        false,
        new ChartInfo('#005A87', PatternFillType.Horizontal, 3));
    
    responsibleGrowthFund: Fund = new Fund(
        4,
        'Responsible Growth Fund',
        'The growth fund aims to grow the amount invested over the long-term (defined as 5 years plus). This fund invests in a wide range of asset classes globally which are accessed through investments into single asset class funds. There is a high allocation to equity markets to generate higher levels of growth over the longer term.',
        true,
        new ChartInfo('#007F99', PatternFillType.ClimbingDiagonal, 4));

    allFunds: Array<Fund> = new Array<Fund>();

    public constructor() {
        this.allFunds.push(this.trusteeBankAccount);
        this.allFunds.push(this.moneyFund);
        this.allFunds.push(this.matchingIncomeFund);
        this.allFunds.push(this.responsibleGrowthFund);
    }
}

const fundInfo = new FundInfo();

export default fundInfo;
